import { render, staticRenderFns } from "./DvScrollRankingBoard.vue?vue&type=template&id=d5dd246a&"
import script from "./DvScrollRankingBoard.vue?vue&type=script&lang=js&"
export * from "./DvScrollRankingBoard.vue?vue&type=script&lang=js&"
import style0 from "./DvScrollRankingBoard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports